export { WeeklyResults } from './weekly-results';
